<template>
    <div class="page-shell reading-page">
        <h1>404 Page Not Found</h1>
    </div>
</template>

<script>
export default {
    name: "Not Found"
}
</script>

<style scoped>

</style>